/* eslint-disable */ /* /* REASON : This needs to be completely refactored /*
WHY : Jon Werber /* WHEN : This will be fixed by 7/21/19 */

<template>
	<main class="home b360-container-row">
		<section class="b360-viewall-header">
			<h1>{{ 'header goes here' }}</h1>
			<p class="description">{{ 'description goes here' }}</p>
		</section>
		<section>
			<h2>card is in here, we just need the end point</h2>
			<ResourceCard v-for="(item, index) in dataFromServer" :key="index" />
		</section>
	</main>
</template>

<script>
import ResourceCard from '@/components/cards/ResourceCard.vue';
import apiClient from '../../services/api-client';

export default {
	name: 'home',
	components: {
		ResourceCard,
	},
	data() {
		return {
			cardData: [],
			mediaType: String,
			documentType: String,
			description: String,
			header: String,
			dataFromServer: [],
		};
	},
	beforeCreate() {
		const endpoint = '/DashboardMenus?title=MarketingResources_Overview';

		apiClient()
			.get(endpoint)
			.then((response) => {
				this.dataFromServer = response.data[0].response[0].children;
			})
			.catch((error) => {
				// eslint-disable-next-line no-console
				console.log(`${endpoint}: ${error}`);
			});
	},
};
</script>

<style lang="scss" scoped>
.b360-container-row {
	.b360-viewall-header {
		margin-bottom: 14px;
		display: flex;
		flex-direction: column;

		h1 {
			margin-bottom: 5px;
		}
	}
}

.b360-viewall-row-video {
	display: grid;
	grid-gap: 30px;

	@include mobile {
		grid-gap: 15px;
		row-gap: 30px;
	}
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.b360-viewall-row-document {
	display: grid;
	grid-gap: 30px;
	grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));

	@include mobile {
		grid-gap: 15px;
		row-gap: 30px;
		grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
	}
}
</style>
